import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import { CommonAnsweredSurveyList } from "./Common/CommonAnsweredSurveyList";

const AnsweredSurveyPage = () => {
    return (
        <PageWrapper title='Questionários respondidos'>
            <Page container='fluid'>
                <div className='row'>
                    <div className='col-12'>
                        <CommonAnsweredSurveyList />
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default AnsweredSurveyPage;